module.exports = __webpack_public_path__ + "media/images/app_store-18a0d7f090a628f98ce723293e4ba0a7.png";